<template>
	<div
		data-aos="fade-up"
		class="relative min-h-80 border-2 border-foreground rounded-3xl backdrop-blur-8 md:min-h-120">
		<div class="flex flex-col gap-2 p-6">
			<h3 class="text-xl">
				گفتگو محور
			</h3>

			<p class="text-foreground/60">
				نگهداری تاریخچه پیام ها مناسب تسک های تحقیقاتی و کمکیار مقالات
			</p>
		</div>

		<NuxtImg
			loading="lazy"
			src="/website/feature-talk.svg"
			width="340"
			height="270"
			class="inset-x-0 bottom-0 block w-full md:absolute" />
	</div>
</template>
